import * as Yup from 'yup'
import {EmployerLoginPassword, Identifier} from 'Validations'

export const Validation = Yup.object({
  identifier: Identifier,
  password: EmployerLoginPassword,
})
